import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  GetMissingInfoDetails,
  orderSummarySelector,
  UploadDocument,
  GetDocStoreDetails,
  GetEmailDetails,
  GetOrderDetails,
  GetInvoiceDetails,
  GetEditOrderDetails,
  GetAllCheckList,
  GetIsCurrentFirmPromptFinancial,
  GetIDVFinalResultReviewdByCTIC,
} from "../features/ordersSummary/orderSummarySlice";
import { OrderSummarySchema } from "../components/schemas/OrderSummarySchema";
import { authLoginSelector } from "../features/auth/authLoginSlice";
import {
  GetFileDetails,
  orderLawyerInfoSelector,
} from "../features/auth/orderLawyerInformationSlice";
import {
  GetDocumentType,
  MergeDocumentExpress,
  uploadDocumentSelector,
} from "../features/uploadDocument/uploadDocumentSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetAllRequiredDocument,
  requiredDocumentSelector,
} from "../features/requiredDocument/requiredDocumentSlice";
import { GetInvoices } from "../features/invoice/invoiceSlice";
import {
  GetFileSummaryExpress,
  orderSliceSelector,
} from "../features/orders/orderSlice";
const useOrderSummary = (ref) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    setFocus,
    trigger,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(OrderSummarySchema),
    mode: "onBlur",
  });

  // const { fields, append, remove } = useFieldArray({
  //   name: 'emailInfo',
  //   control,
  // });

  const {
    MissingInfos,
    DocStoreDetails,
    EmailIds,
    OrderDetails,
    InvoiceDetails,
    success,
    isCurrentFirmPromptFinancial,
    IDVFinalResultReviewdByCTIC,
  } = useSelector(orderSummarySelector);

  const { fileSummaryDetails } = useSelector(orderSliceSelector);

  const requiredDocRef = useRef();
  const dispatch = useDispatch();
  const [missingInfoList, setMissingInfoList] = useState([]);
  const [docStoreList, setdocStoreList] = useState([]);
  const [propertyArray, setPropertyArray] = useState([]);
  const [documentTypeArray, setDocumentTypeArray] = useState([]);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { userLogin } = useSelector(authLoginSelector);
  const MissingDocsUploadForm = () => {
    requiredDocRef.current.handlesubmitform();
  };
  const { postOrderDetailsInfo, fileDetailsInfo } = useSelector(
    orderLawyerInfoSelector,
  );
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const { editOrderDetails, checkListDetails } =
    useSelector(orderSummarySelector);
  const { DocumentTypes, MergeSuccess, loading } = useSelector(
    uploadDocumentSelector,
  );
  const { requiredDocument } = useSelector(requiredDocumentSelector);
  const [isMergeSelected, setisMergeSelected] = useState(0);
  const [isEmailSelected, setisEmailSelected] = useState(0);
  const [docErrorMessageMerge, setdocErrorMessageMerge] = useState("");
  const [isCancelOrderVisible, setIsCancelOrderVisible] = useState(false);

  useEffect(() => {
    const firstError = Object.keys(errors).reduce((field, a) => {
      return !!errors[field] ? field : a;
    }, null);
    if (firstError) {
      setFocus(firstError);
    }
  }, [errors, setFocus]);

  useEffect(() => {
    if (
      postOrderDetailsInfo?.firmId ||
      localStorage.getItem("selectedFirmId")
    ) {
      dispatch(
        GetIsCurrentFirmPromptFinancial(
          postOrderDetailsInfo?.firmId ||
          localStorage.getItem("selectedFirmId"),
        ),
      );
    }
  }, [localStorage.getItem("selectedFirmId"), postOrderDetailsInfo?.firmId]);

  useEffect(() => {
    if (
      postOrderDetailsInfo &&
      postOrderDetailsInfo?.fileID &&
      isCurrentFirmPromptFinancial === true
    ) {
      dispatch(GetIDVFinalResultReviewdByCTIC(postOrderDetailsInfo?.fileID));
    }
  }, [postOrderDetailsInfo?.fileID, isCurrentFirmPromptFinancial]);

  useEffect(() => {
    if (
      (postOrderDetailsInfo?.fileID !== undefined &&
        postOrderDetailsInfo?.fileID > 0) ||
      id
    )
      dispatch(
        GetEditOrderDetails(
          postOrderDetailsInfo?.fileID || Number(id) - 100000,
          userLogin.userId,
        ),
      );
    dispatch(GetAllCheckList(postOrderDetailsInfo?.fileID));
    dispatch(GetDocumentType(postOrderDetailsInfo?.fileID, userLogin.userId));
  }, [postOrderDetailsInfo?.fileID]);

  useEffect(() => {
    let propertyArray =
      editOrderDetails?.propertyList?.length === 1
        ? [
          {
            value: 1,
            label: "For this order",
          },
        ]
        : editOrderDetails?.propertyList?.length > 1
          ? [
            editOrderDetails?.propertyList?.length > 1 && {
              value: 1,
              label: "For this order",
            },
          ]
          : [];
    editOrderDetails?.propertyList?.length > 1 &&
      editOrderDetails?.propertyList.forEach((element, index) => {
        propertyArray.push({
          value: element.id,
          label: (
            <span>
              <b>Property {index + 1}</b> - {element.address1}{" "}
              {element.address2}, {element.cityTown || ""},{" "}
              {element.provinceState} {element.postalZip}
            </span>
          ),
          propertyNumber: `Property ${index + 1}`,
        });
      });
    setPropertyArray(propertyArray);
  }, [editOrderDetails]);

  useEffect(() => {
    let documentTypeArray = [];
    DocumentTypes.forEach((element, index) => {
      documentTypeArray.push({
        value: element?.documentType,
        label:
          currentLanguage === "fr"
            ? element?.documentType_FR
            : element?.documentType,
        id: element?.documentTypeID,
      });
    });
    setDocumentTypeArray(
      documentTypeArray?.sort((a, b) => a?.label?.localeCompare(b?.label)),
    );
  }, [DocumentTypes, currentLanguage]);

  const formSubmit = async (data) => {
    dispatch(UploadDocument(data));
  };

  const DocStoreformSubmit = async (data) => {
    if (!data.DocStoreIDArray || data.DocStoreIDArray.length < 2) {
      setisMergeSelected(1);
      setdocErrorMessageMerge("Select at least 2 documents");
      return;
    }

    let request = {
      FileDetails:
        data.DocStoreIDArray.length === 1
          ? [data.DocStoreIDArray.length]
          : data.DocStoreIDArray,
      FileID: postOrderDetailsInfo?.fileID,
      FileNumber: postOrderDetailsInfo?.fileNumber,
      UserID: userLogin.userId,
      DocName: data.DocumentPackage,
    };
    setValue("DocumentPackage", "");
    dispatch(MergeDocumentExpress(request));
    setisMergeSelected(0);
  };

  const dropdownChange = (e, name) => {
    setValue(name, e);
    trigger(name);
  };

  useEffect(() => {
    if (MissingInfos === null || MissingInfos?.length <= 0) {
      //dispatch(GetMissingInfoDetails(497226,"en-CA"));//need to uncomment
    } else {
      setMissingInfoList(
        MissingInfos?.map((missing, index) => ({
          id: missing.id,
          problem: missing.problem,
          problemName: missing.problemName,
          date: missing.date,
        })),
      );
    }
  }, [MissingInfos]);

  useEffect(() => {
    if (DocStoreDetails === null || DocStoreDetails?.length === 0) {
      dispatch(GetEmailDetails(497226));
    }
  }, [EmailIds]);

  useEffect(() => {
    if (postOrderDetailsInfo === null || postOrderDetailsInfo.length === 0) {
      dispatch(GetFileDetails(parseInt(id) - 100000));
    }
  }, [postOrderDetailsInfo]);

  useEffect(() => {
    // if (DocStoreDetails === null || DocStoreDetails?.length === 0) {
    dispatch(GetInvoices(postOrderDetailsInfo?.fileID));
    // }
  }, [postOrderDetailsInfo]);

  useEffect(() => {
    if (!fileSummaryDetails || fileSummaryDetails === null) {
      if (id !== undefined)
        dispatch(GetFileSummaryExpress(id - 100000, userLogin?.userId));
    }
  }, [id, fileSummaryDetails]);

  useEffect(() => {
    //if (DocStoreDetails?.DocStore === undefined) {
      dispatch(
        GetDocStoreDetails(postOrderDetailsInfo?.fileID, userLogin.userId),
      );
   // }
    MoveUP();
  }, [postOrderDetailsInfo?.fileID]);

  const GetAllFileDetailsByFileId = () => {
    dispatch(
      GetEditOrderDetails(postOrderDetailsInfo?.fileID, userLogin.userId),
    ).then((result) => {
      navigate("/order");
    });
  };

  useEffect(() => {
    dispatch(GetAllRequiredDocument(parseInt(id) - 100000, userLogin.userId));
  }, []);

  function MoveUP() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  useEffect(() => {
    if (
      (postOrderDetailsInfo?.fileID !== undefined &&
        !userLogin?.internalUser &&
        postOrderDetailsInfo?.fileStatus !== "Cancellation Pending" &&
        postOrderDetailsInfo?.fileStatus !== "Cancelled") ||
      (postOrderDetailsInfo?.fileID !== undefined &&
        userLogin?.internalUser &&
        postOrderDetailsInfo?.fileStatus === "Cancellation Pending")
    ) {
      setIsCancelOrderVisible(true);
    } else {
      setIsCancelOrderVisible(false);
    }
  }, [postOrderDetailsInfo]);

  return {
    t,
    MissingInfos,
    DocStoreDetails,
    dispatch,
    missingInfoList,
    register,
    requiredDocRef,
    getValues,
    control,
    setValue,
    errors,
    setFocus,
    dropdownChange,
    handleSubmit,
    formSubmit,
    trigger,
    DocStoreformSubmit,
    EmailIds,
    watch,
    reset,
    OrderDetails,
    InvoiceDetails,
    GetAllFileDetailsByFileId,
    postOrderDetailsInfo,
    fileDetailsInfo,
    checkListDetails,
    userLogin,
    propertyArray,
    documentTypeArray,
    loading,
    isMergeSelected,
    setisMergeSelected,
    isEmailSelected,
    setisEmailSelected,
    id,
    docErrorMessageMerge,
    setdocErrorMessageMerge,
    ToastContainer,
    toast,
    requiredDocument,
    isCancelOrderVisible,
    currentLanguage,
    editOrderDetails,
    fileSummaryDetails,
    isCurrentFirmPromptFinancial,
    IDVFinalResultReviewdByCTIC,
  };
};

export default useOrderSummary;
